import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDealStore } from '@/stores/deal-store'
import { DealForm } from '@/components/deals/DealForm'
import type { DealInput } from '@/lib/schema'
import { ArrowLeft } from 'lucide-react'
import { Link } from 'react-router-dom'

export function NewDealPage() {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const { createDeal } = useDealStore()
  const navigate = useNavigate()

  const handleSubmit = async (data: DealInput) => {
    setIsSubmitting(true)
    setError(null)
    try {
      const deal = await createDeal(data)
      navigate(`/deals/${deal.id}`)
    } catch (err) {
      setError((err as Error).message)
      setIsSubmitting(false)
    }
  }

  return (
    <div>
      <div className="mb-6">
        <Link
          to="/deals"
          className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-slate-700"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to Deals
        </Link>
        <h1 className="mt-4">New Deal</h1>
        <p className="mt-1 text-slate-500">Enter property details to analyze the investment.</p>
      </div>

      {error && (
        <div className="mb-6 rounded-lg border border-danger-200 bg-danger-50 px-4 py-3 text-danger-700">
          {error}
        </div>
      )}

      <DealForm onSubmit={handleSubmit} isSubmitting={isSubmitting} />
    </div>
  )
}
